(ns teamoesterreich.user-mode.profile.profile-personal
  (:require
    [clojure.string]
    [goog.date.DateTime]
    [goog.string.format]
    [reagent-material-ui.components :as mui]
    ;;(h/event-value e)
    [reagent-material-ui.icons.add :refer [add]]
    [reagent-material-ui.icons.cake :refer [cake]]
    [reagent-material-ui.icons.cancel :refer [cancel]]
    [reagent-material-ui.icons.cancel :refer [cancel]]
    [reagent-material-ui.icons.delete-forever :refer [delete-forever]]
    [reagent-material-ui.icons.edit :refer [edit]]
    [reagent-material-ui.icons.email :refer [email]]

    [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
    [reagent-material-ui.icons.phone :refer [phone]]
    [reagent-material-ui.icons.photo :refer [photo]]
    [reagent-material-ui.icons.save :refer [save]]



    [reagent-material-ui.icons.security :refer [security]]


    [reagent.core :as r]
    [shadow.cljs.modern :refer (js-await)]
    [teamoesterreich.firebase.storage-provider :as storage-provider]
    [teamoesterreich.store :as store]
    [teamoesterreich.text.get-text :as txt]
    [teamoesterreich.user-mode.actions :as a]
    [teamoesterreich.user-mode.navigation.bottom-bar :as bottom-bar]
    [teamoesterreich.user-mode.profile.lists :as lists]
    [teamoesterreich.user-mode.profile.profile-address-part :as address-part]
    [teamoesterreich.user-mode.profile.profile-qualifications :as p-qualifications]
    [teamoesterreich.user-mode.ui-helper.are-you-sure-modal :as ays-modal]
    [teamoesterreich.util.helper :as h]

    [teamoesterreich.util.log :as log]

    ))


(defonce date-picker-state (r/atom nil))


(defn parseDateFieldToTimestamp [dStr]
  (js/firebase.firestore.Timestamp.fromMillis (js/Date.parse (str dStr " 10:00:00"))))

(defn unParseDateFieldToTimestamp [ts]
  (let [date (if ts (.toDate ^js ts) (js/Date.))]
    (goog.string.format "%04d-%02d-%02d" (.getFullYear date) (inc (.getMonth date)) (.getDate date))
    ))

(defn is-phone? [e] (not (nil? (re-matches #"^\+(?:[0-9]●?){6,14}[0-9]$" (str e)))))
(defn is-email? [e] (not (nil? (re-matches #"^\S+@\S+\.\S+$" (str e)))))


(defn save-user [user-obj]
  (a/set-user-details (merge user-obj)))



(defn profile-image [!userId !actual-user]
  (let [!state (r/atom {:progress nil})
        on-done-fn (fn [new-path]
                     (log/out "image uploaded to:" new-path)
                     (save-user {:portrait-path new-path})
                     )]
    (log/out "profile-image " (:portrait-path-fst @!actual-user) (:portrait-path @!actual-user))
    [mui/grid
     {:container false
      :item      true
      :xs        12}
     [mui/grid
      {:container true
       :spacing   4
       }
      [mui/grid
       {:container false
        :item      true
        :sm        6
        :xs        12
        :style     {:height "160px" :textAlign "center"}
        }
       [mui/avatar {:src   (or (:portrait-path-fst @!actual-user) "/custom/img/placeholder-md.png")
                    :style {:height "120px" :width "120px" :margin "15px 10px 10px 20px"}
                    }]]
      [mui/grid
       {:container false
        :item      true
        :sm        6
        :xs        12
        }
       [mui/button {
                    :variant   "contained"
                    ;:class bottom-button-class
                    :startIcon (r/as-element [photo])
                    :component "label"
                    :style     {:width "200px" :margin "10px 0 0 0"}
                    }
        "Neues Foto" (when (:progress @!state) (str " ... " (:progress @!state) "%"))
        [:input {:accept   "image/" :id "photoUpload"
                 :type     "file"
                 :hidden   true
                 :onChange (fn [e]
                             (log/out "upload fired..." "files" (.item e.target.files 0))
                             (storage-provider/upload-user-image (.item e.target.files 0) @!userId
                                                                 (fn [path] (on-done-fn path) (swap! !state assoc :progress nil))
                                                                 (fn [p] (swap! !state assoc :progress p)))
                             )
                 }]]
       [:br]

       [mui/button
        {:variant   "contained"
         :startIcon (r/as-element [delete-forever])
         :style     {:width "200px" :margin "10px 0 0 0"}
         :onClick   (fn []
                      (swap! !actual-user dissoc :portrait-path-fst)
                      (save-user {:portrait-path nil}))
         }
        "Löschen"]
       ]]]
    ))



(defn save-cancel [{:keys [bottom-button-class do-save? cancel-fn save-fn]}]
  [:<>
   [mui/grid
    {:container false
     :md        6                                           ;medium: 960px
     :xs        6                                           ;extra-small: 0px
     :style     {:padding "15px"}
     }
    [mui/button
     {:variant   "contained"
      :class     bottom-button-class
      :disabled  (not do-save?)

      :startIcon (r/as-element [cancel])

      :style     {:margin "10px 0 10px 10px"}
      :onClick   cancel-fn
      }
     "Abbrechen"]

    ]
   [mui/grid
    {:container false
     :md        6                                           ;medium: 960px
     :xs        6                                           ;extra-small: 0px
     :style     {:padding "15px"}
     }
    [mui/button
     {:variant   "contained"
      :color     "primary"
      :class     bottom-button-class
      :disabled  (not do-save?)

      :startIcon (r/as-element [save])

      :style     {:margin "10px 0 10px 10px"}
      :onClick   save-fn
      }
     "Speichern"]

    ]])

(defn get-it [& [{:keys [go-back save-at-bottom show-languages show-open-location] :or {go-back            #(a/set-page-back)
                                                                                        show-open-location true}}]]
  (let [!profile-state (r/cursor store/app-state [:profile-state])
        !actual-user (r/cursor store/app-state [:actual-user])
        !userId (r/cursor store/app-state [:firebase-uid])
        !user-form (r/cursor !profile-state [:personal-form])
        !lose-data-modal (r/cursor !profile-state [:personal-form :show-lose-data-form-modal])
        !u-addr-ch (r/cursor !profile-state [:personal-form :address-form])

        !qualification-form (r/cursor !profile-state [:qualification-form])

        u-title (or (get-in @!user-form [:name :title]) (get-in @!actual-user [:name :title]))
        u-title-ch (and (get-in @!user-form [:name :title]) (not= (get-in @!user-form [:name :title]) (get-in @!actual-user [:name :title])))

        u-first (or (get-in @!user-form [:name :first]) (get-in @!actual-user [:name :first]))
        u-first-ch (and (get-in @!user-form [:name :first]) (not= (get-in @!user-form [:name :first]) (get-in @!actual-user [:name :first])))
        u-last (or (get-in @!user-form [:name :last]) (get-in @!actual-user [:name :last]))
        u-last-ch (and (get-in @!user-form [:name :last]) (not= (get-in @!user-form [:name :last]) (get-in @!actual-user [:name :last])))


        u-gender (or (get-in @!user-form [:gender]) (get-in @!actual-user [:gender]))
        u-gender-ch (and (get-in @!user-form [:gender]) (not= (get-in @!user-form [:gender]) (get-in @!actual-user [:gender])))
        u-nationality (or (get-in @!user-form [:nationality]) (get-in @!actual-user [:nationality]))
        u-nationality-ch (and (get-in @!user-form [:nationality]) (not= (get-in @!user-form [:nationality]) (get-in @!actual-user [:nationality])))

        u-birthday (or (get-in @!user-form [:birthday]) (get-in @!actual-user [:birthday]))
        u-birthday-ch (and (get-in @!user-form [:birthday]) (not= (get-in @!user-form [:birthday]) (get-in @!actual-user [:birthday])))
        u-birthplace (or (get-in @!user-form [:birthplace]) (get-in @!actual-user [:birthplace]))
        u-birthplace-ch (and (get-in @!user-form [:birthplace]) (not= (get-in @!user-form [:birthplace]) (get-in @!actual-user [:birthplace])))

        u-clothing-size (or (get-in @!user-form [:clothing-size]) (get-in @!actual-user [:clothing-size]))
        u-clothing-size-ch (and (get-in @!user-form [:clothing-size]) (not= (get-in @!user-form [:clothing-size]) (get-in @!actual-user [:clothing-size])))


        u-phone (or (get-in @!user-form [:phone]) (get-in @!actual-user [:phone]))
        u-phone-ch (and (get-in @!user-form [:phone]) (not= (get-in @!user-form [:phone]) (get-in @!actual-user [:phone])))
        u-email (or (get-in @!user-form [:email]) (get-in @!actual-user [:email]))
        u-email-ch (and (get-in @!user-form [:email]) (not= (get-in @!user-form [:email]) (get-in @!actual-user [:email])))

        u-hdy-valid-code-ch (and (get-in @!user-form [:hdy-valid-code]) (not= (get-in @!user-form [:hdy-valid-code]) (get-in @!actual-user [:hdy-valid-code])))

        do-save? (or
                   u-title-ch
                   u-first-ch
                   u-last-ch

                   u-gender-ch

                   u-birthday-ch
                   u-birthplace-ch

                   u-nationality-ch
                   u-clothing-size-ch

                   @!u-addr-ch

                   u-phone-ch
                   u-email-ch

                   u-hdy-valid-code-ch

                   (let [a (get-in @!actual-user [:languages])
                         b (get-in @!qualification-form [:languages])]
                     (if (map? a) (not= a (merge a b))
                                  (and (not (nil? b)) (not= a b))))
                   )

        save-fn (fn []
                  (swap! !qualification-form assoc :languages (reduce (fn [c [k e]]
                                                                        (cond
                                                                          (= e "") c
                                                                          (= e "del") (assoc c k (js/firebase.firestore.FieldValue.delete))
                                                                          :else (assoc c k e)))
                                                                      {}
                                                                      (dissoc (merge
                                                                                (:languages @!actual-user)
                                                                                (:languages @!qualification-form)) "")))


                  (let [data (merge @!qualification-form @!user-form)]
                    (log/out "save form" data)
                    (js-await [_ (save-user data)]
                      (reset! !user-form nil)
                      (reset! !qualification-form nil)))
                  )

        change-fn (fn [key] (fn [e]
                              (log/out "Change " key "-> " (h/event-value e))
                              (swap! !user-form assoc-in key (h/event-value e))
                              ))


        real-back-fn (fn []
                       (log/out "real-back-fn")
                       (.scrollTo js/window 0 0)
                       (swap! !profile-state assoc :personal-form {})
                       (go-back)
                       )

        back-fn (fn [_]
                  (log/out "back-fn called")
                  (if do-save?
                    (swap! !user-form assoc :show-lose-data-form-modal true)
                    (real-back-fn)))

        bottom-button-class (if save-at-bottom "" "bottom-button")
        ]
    (bottom-bar/set-actions back-fn (when do-save? save-fn))

    [mui/grid
     {:container  true
      :direction  "column"
      :justify    "center"
      :alignItems "center"
      :style      {:marginTop "25px"}
      }

     [mui/grid
      {:container false
       :md        6                                         ;medium: 960px
       :xs        12                                        ;extra-small: 0px
       }
      [mui/paper {:class ""
                  :style {:textAlign "left" :padding "25px"}}
       [ays-modal/are-you-sure-modal !lose-data-modal "Dieses Formular hat nicht gespeicherte Daten. Willst du es wirklich schließen?" "Eingabe verwerfen" real-back-fn]
       [mui/grid
        {:container  true
         :direction  "column"
         :justify    "space-between"
         :alignItems "flex-start"
         :spacing    1
         }
        [mui/grid
         {:container false
          :xs        12                                     ;extra-small: 0px
          :spacing   4
          }
         [:span "" (:tom-id @!actual-user) ""]
         [:h1 "Mein Profil Bild"]
         ]

        [profile-image !userId !actual-user]

        [mui/grid
         {:container false
          :xs        12                                     ;extra-small: 0px
          :spacing   4
          }
         [:h1 "Meine persönlichen Daten  "]
         ]
        [mui/grid
         {:container  true
          :direction  "row"
          :justify    "flex-start"
          :alignItems "flex-start"
          :spacing    1
          :style      {:margin "0"}
          }
         [mui/grid
          {:container false
           :md        3                                     ;medium: 960px
           :xs        12                                    ;extra-small: 0px
           :style     {:padding "15px"}
           }
          [mui/text-field {
                           :style           {:backgroundColor (if u-title-ch "#ffd6d2" "#ffffff")}
                           :fullWidth       true
                           :InputLabelProps {:disableAnimation true :shrink true}
                           :defaultValue    u-title
                           :onChange        (change-fn [:name :title])
                           :label           "Titel"}]

          ]
         [mui/grid
          {:container false
           :md        4                                     ;medium: 960px
           :xs        12                                    ;extra-small: 0px
           :style     {:padding "15px"}
           }
          [mui/text-field {
                           :style           {:backgroundColor (if u-first-ch "#ffd6d2" "#ffffff")}
                           :fullWidth       true
                           :InputLabelProps {:disableAnimation true :shrink true}
                           :defaultValue    u-first
                           :onChange        (change-fn [:name :first])
                           :label           "Vorname ⁽*⁾"
                           :error           (empty? u-first)
                           }]

          ]
         [mui/grid
          {:container false
           :md        4                                     ;medium: 960px
           :xs        12                                    ;extra-small: 0px
           :style     {:padding "15px"}
           }
          [mui/text-field {
                           :style           {:backgroundColor (if u-last-ch "#ffd6d2" "#ffffff")}
                           :fullWidth       true
                           :InputLabelProps {:disableAnimation true :shrink true}
                           :defaultValue    u-last
                           ;:variant "filled"
                           :onChange        (change-fn [:name :last])
                           :label           "Nachname ⁽*⁾"
                           :error           (empty? u-first)
                           }]

          ]

         [mui/grid
          {:container false
           :md        4                                     ;medium: 960px
           :xs        12                                    ;extra-small: 0px
           :style     {:padding "15px"}
           }

          [mui/form-control {:variant "standard" :fullWidth true}
           [mui/input-label {:id    "gender-label" :shrink true :disableAnimation true
                             :error (empty? u-gender)}
            "Geschlecht ⁽*⁾"]
           [mui/select
            {
             :style     {:backgroundColor (if u-gender-ch "#ffd6d2" "#ffffff")}
             :fullWidth true
             :value     u-gender
             :onChange  (change-fn [:gender])
             :label     "Geschlecht ⁽*⁾"
             :error     (empty? u-gender)
             :labelId   "gender-label"
             }

            [mui/menu-item {:value "m" :key "gender_m"} "Mann"]
            [mui/menu-item {:value "f" :key "gender_w"} "Frau"]
            [mui/menu-item {:value "o" :key "gender_a"} "Anderes"]
            ]]

          ]

         [mui/grid
          {:container false
           :md        4                                     ;medium: 960px
           :xs        12                                    ;extra-small: 0px
           :style     {:padding "10px"}
           }

          [mui/text-field {
                           :style           {:backgroundColor (if u-birthday-ch "#ffd6d2" "#ffffff")}
                           :fullWidth       true
                           :InputLabelProps {:disableAnimation true :shrink true}
                           :type            "date"
                           :size            "small"
                           :format          "dd.MM.yyyy"
                           :label           (str "Geburtsdatum ⁽*⁾ ")
                           ;:onChange (change-fn [:birthplace])
                           :onChange        (fn [e]
                                              (log/out "update birthdate " (h/event-value e) " -- " (parseDateFieldToTimestamp (h/event-value e)) " <-- ")
                                              (swap! !user-form assoc-in [:birthday] (parseDateFieldToTimestamp (h/event-value e)))
                                              )
                           :error           (or (nil? u-birthday) (< u-birthday 0))
                           :defaultValue    (when u-birthday (unParseDateFieldToTimestamp u-birthday))
                           :helperText      (if (or (nil? u-birthday) (< u-birthday 0)) "Geburtsdatum ist ein Pflichtfeld" "")
                           :InputProps      {:startAdornment (r/as-element [mui/input-adornment {:position "start"} [cake {:style {:font-size "14px"}}]])}
                           }]

          ]





         [mui/grid
          {:container false
           :md        3                                     ;medium: 960px
           :xs        12                                    ;extra-small: 0px
           :style     {:padding "15px"}
           }

          [mui/form-control {:variant "standard" :fullWidth true}
           [mui/input-label {:id "clothing-size-label" :shrink true :disableAnimation true} "Kleidergröße"]
           [mui/select
            {
             :style     {:backgroundColor (if u-clothing-size-ch "#ffd6d2" "#ffffff")}
             :fullWidth true
             :value     u-clothing-size
             :onChange  (change-fn [:clothing-size])
             :label     "Kleidergröße"
             :labelId   "clothing-size-label"
             }

            (for [[l-key l-name] lists/CLOTHING_SIZE]
              ^{:key (str "cloth-" l-key)} [mui/menu-item {:value l-key :key l-key} l-name])
            ]
           ]
          [:span {:style {:fontSize "8px"}} "Falls wir dir im Einsatz Bekleidung zur Verfügung stellen wollen."]]

         [mui/grid
          {:container false
           :xs        12                                    ;extra-small: 0px
           :spacing   4
           }
          [:h1 "Kontakt"]
          ]
         [mui/grid
          {:container false
           :md        7                                     ;medium: 960px
           :xs        12                                    ;extra-small: 0px
           :style     {:padding "15px"}
           }
          [mui/text-field {
                           :InputProps {:startAdornment (r/as-element [mui/input-adornment {:position "start"} [phone]])}
                           :fullWidth  true
                           :label      "Mobilnummer ⁽*⁾"
                           :disabled   true
                           :helperText (if (get-in @!actual-user [:hdy-valid]) "Mobilnummer wurde validiert" "Mobilnummer wurde noch nicht validiert")
                           :value      u-phone
                           :error      (not (get-in @!actual-user [:hdy-valid]))
                           }]]

         [mui/grid
          {:container false
           :md        5                                     ;medium: 960px
           :xs        12                                    ;extra-small: 0px
           :spacing   4
           }
          [mui/box {:sx {:display        "flex"
                         :flex-direction {:xs "column" :lg "row"}
                         :gap            ".5rem"}}
           (when (not (:hdy-valid @!actual-user))
             [mui/button
              {
               :style     {:justifyContent "left" :flex 1}
               :variant   "contained"
               :color     "secondary"
               :title     "Erforderlich für vollständiges Profil"
               :startIcon (r/as-element [security])
               :onClick   #(a/verify-phone-number)
               }
              "Verifizieren"])
           [mui/button
            {
             :style     {:justifyContent "left" :flex 1}
             :variant   "contained"
             ;:color "primary"
             :title     "Erforderlich für vollständiges Profil"
             :startIcon (r/as-element [edit])
             :onClick   #(a/update-phone-number)
             }
            "Ändern"]]]

         [mui/grid
          {:container false
           :md        7                                     ;medium: 960px
           :xs        12                                    ;extra-small: 0px
           :style     {:padding "15px"}
           }
          [mui/text-field {
                           :InputProps {:startAdornment (r/as-element [mui/input-adornment {:position "start"} [email]])}
                           :fullWidth  true
                           :label      "Emailadresse ⁽*⁾"
                           :helperText (if (get-in @!actual-user [:email-confirmed]) "Email wurde validiert" "Email wurde noch nicht validiert")
                           :value      u-email
                           :disabled   true
                           :error      (not (get-in @!actual-user [:email-confirmed]))
                           }]]

         [mui/grid
          {:container false
           :md        5                                     ;medium: 960px
           :xs        12                                    ;extra-small: 0px
           :spacing   4
           }
          [mui/box {:sx {:display        "flex"
                         :flex-direction {:xs "column" :lg "row"}
                         :gap            ".5rem"}}
           (when (not (:email-confirmed @!actual-user))
             [mui/button
              {
               :style     {:justifyContent "left" :flex 1}
               :variant   "contained"
               :color     "secondary"
               :title     "Erforderlich für vollständiges Profil"
               :startIcon (r/as-element [security])
               :onClick   #(a/verify-email)
               }
              "Verifizieren"])
           [mui/button
            {
             :style     {:justifyContent "left" :flex 1}
             :variant   "contained"
             ;:color "primary"
             :title     "Erforderlich für vollständiges Profil"
             :startIcon (r/as-element [edit])
             :onClick   #(a/update-email)
             }
            "Ändern"]]]

         [mui/grid
          {:container false
           :xs        12                                    ;extra-small: 0px
           :style     {:padding "5px"}
           }
          ]

         (when-not save-at-bottom
           [save-cancel {:bottom-button-class bottom-button-class
                         :do-save?            do-save?
                         :cancel-fn           (fn []
                                                (reset! !user-form nil)
                                                (reset! !qualification-form nil))
                         :save-fn             save-fn}])



         ;; ########################### ADDRESS ##########################
         [mui/grid
          {:container false
           :xs        12                                    ;extra-small: 0px
           :style     {:padding "15px"}
           }
          [(address-part/address-part !actual-user show-open-location)]]

         (when show-languages
           [:<>
            [mui/grid
             {:container false
              :xs        12                                 ;extra-small: 0px
              :style     {:padding "15px"}
              }
             [mui/typography {:color (if (empty? (:languages @!actual-user)) "error" "textPrimary") :variant "h6"}
              "Sprachen ⁽*⁾"]
             ]

            (p-qualifications/get-languages !actual-user !qualification-form)
            [mui/grid
             {:container false
              :xs        12                                 ;extra-small: 0px
              :style     {:padding "15px"}
              }
             [mui/button
              {:variant   "contained"
               :startIcon (r/as-element [add])
               :style     {:margin "10px 0 10px 10px" :width "160px"}
               :onClick   (fn []
                            (swap! !qualification-form assoc-in [:languages ""] "basic")
                            (log/log "added lang" @!qualification-form)
                            )
               }
              "Weitere"]
             ]])

         [mui/grid
          {:container false
           :xs        12                                    ;extra-small: 0px
           :style     {:padding "5px"}
           }
          [:p ""]]

         (when save-at-bottom
           [save-cancel {:bottom-button-class bottom-button-class
                         :do-save?            do-save?
                         :cancel-fn           (fn []
                                                (reset! !user-form nil)
                                                (reset! !qualification-form nil))
                         :save-fn             save-fn}])

         [mui/grid
          {:container false
           :md        6                                     ;medium: 960px
           :xs        6                                     ;extra-small: 0px
           :style     {:padding "15px"}
           }
          [mui/button
           {:variant   "contained"
            :class     bottom-button-class
            :style     {:margin "10px 0 10px 10px"}
            :onClick   back-fn
            :startIcon (r/as-element [keyboard-arrow-left])
            }
           "Zurück"]

          ]


         [:p (txt/txt :profile "Du musst die mit ⁽*⁾ markierten Felder ausfüllen")]

         ]

        ]

       ]]]
    ))
